import { createAsyncActionType } from './index';

export const DOCUMENTS_EXPERT_LIST_GET = createAsyncActionType(
  'documentsExpert',
  'DOCUMENTS_EXPERT_LIST_GET'
);

export const DOCUMENT_EXPERT_DETAILS_GET = createAsyncActionType(
  'documentsExpert',
  'DOCUMENT_EXPERT_DETAILS_GET'
);

export const DOCUMENTS_EXPERT_CATEGORIES_GET = createAsyncActionType(
  'documentsExpert',
  'DOCUMENTS_EXPERT_CATEGORIES_GET'
);

export const DOCUMENT_EXPERT_DETAILS_RESET =
  '@@documentsExpert/DOCUMENT_EXPERT_DETAILS_RESET';

export const DOCUMENTS_EXPERT_DOCUMENT_CREATE = createAsyncActionType(
  'documentsExpert',
  'DOCUMENTS_EXPERT_DOCUMENT_CREATE'
);

export const DOCUMENTS_EXPERT_DOCUMENT_DELETE = createAsyncActionType(
  'documentsExpert',
  'DOCUMENTS_EXPERT_DOCUMENT_DELETE'
);

export const DOCUMENT_EXPERT_SET_COMMENT = createAsyncActionType(
  'documentsExpert',
  'DOCUMENT_EXPERT_SET_COMMENT'
);

export const DOCUMENT_EXPERT_SET_COMMENT_REPLY = createAsyncActionType(
  'documentsExpert',
  'DOCUMENT_EXPERT_SET_COMMENT_REPLY'
);

export const DOCUMENT_EXPERT_GET_COMMENTS = createAsyncActionType(
  'documentsExpert',
  'DOCUMENT_EXPERT_GET_COMMENTS'
);
